"use client";

import { BorderText } from "@/components/custom/border-text";
import dynamic from "next/dynamic";

const SilkBg = dynamic(() => import("@/components/custom/silk-bg"), {
  ssr: false,
});
import TextMarqueeSection from "@/components/custom/text-marquee-section";

const HEIGHT = 800;

export default function HeroSection() {
  return (
    <>
      <div
        className="pt-10"
        style={{
          height: `${HEIGHT}px`,
        }}
      >
        <TextMarqueeSection
          noAnimation
          text={
            <>
              Technology for <BorderText>Building</BorderText>
            </>
          }
          text2={<>Industry</>}
        />
        <div className="text-center mt-8 px-4">
          <p className="text-lg md:text-xl lg:text-2xl text-secondary max-w-3xl mx-auto">
            Machines, Rotors, Stators and equipment for the building industry.
          </p>
        </div>
      </div>
      <SilkBg height={HEIGHT} />
    </>
  );
}
